import { ResourcesConfig } from 'aws-amplify';
import { CookieStorage } from 'aws-amplify/utils';

// Determine redirect URLs based on environment
const isProduction = typeof window !== 'undefined' && window.location.hostname !== 'localhost';
const redirectUrl = isProduction
    ? 'https://youraura.life/'
    : 'http://localhost:4028/';

export const authConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID || '',
            userPoolClientId: process.env.NEXT_PUBLIC_AWS_USER_POOL_WEB_CLIENT_ID || '',
            loginWith: {
                email: true,
                oauth: {
                    domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN || '',
                    scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
                    redirectSignIn: [redirectUrl],
                    redirectSignOut: [redirectUrl],
                    responseType: 'code',
                    providers: ['Google'],
                },
            },
            signUpVerificationMethod: 'code',
            userAttributes: {
                email: {
                    required: true,
                },
            },
            passwordFormat: {
                minLength: 8,
                requireLowercase: true,
                requireUppercase: true,
                requireNumbers: true,
                requireSpecialCharacters: true,
            },
        },
    },
};

// Cookie storage for better session persistence in SSR
export const cookieStorage = new CookieStorage({
    domain: isProduction ? '.youraura.life' : 'localhost',
    path: '/',
    expires: 365,
    sameSite: 'lax',
    secure: isProduction,
});
